import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import { COMPENSATION_TICKET } from "./Compensation";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export const VALUE_CODE = "värdekod";
export const BANKDEPOSIT = "bankkonto";

export default function RefundPreference() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    useEffect(() => {
        if (formData.compensation === COMPENSATION_TICKET) {
            setFormData((prev) => ({
                ...prev,
                taxireceipt: [],
                distance: "",
                cartravelfrom: "",
                cartravelto: "",
                carlicenceplate: "",
                carexpenses: []
            }));
        }
    }, [formData.compensation, setFormData]);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    if (values.refundpreference === VALUE_CODE) {
                        navigate("/vardekod");
                    } else if (values.refundpreference === BANKDEPOSIT) {
                        navigate("/bankinsattning");
                    }

                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    refundpreference: Yup.string().test(
                        "at-least-one-radio-selected",
                        "Vänligen välj ett svarsalternativ för att gå vidare till nästa steg",
                        (value) => {
                            return value === VALUE_CODE ||
                                value === BANKDEPOSIT
                        }
                    ),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"70"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="refundPreference">
                                    Hur vill du ha ersättningen utbetald?
                                </h2>

                                <p>
                                    Om du väljer att få ersättningen som en värdekod får du ersättningen plus 10 kronor extra.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <div
                                    role="radiogroup"
                                    aria-labelledby="refundPreference"
                                    className="radio-group"
                                >
                                    {errors.refundpreference && (
                                        <span
                                            aria-describedby="forMe forOther"
                                            className="validation-error"
                                        >
                                            {errors.refundpreference.toString()}
                                        </span>
                                    )}

                                    <div className={errors.refundpreference ? "has-error" : ""}>
                                        <Field
                                            id="withApp"
                                            type="radio"
                                            name="refundpreference"
                                            value={VALUE_CODE}
                                            checked={values.refundpreference === VALUE_CODE}
                                        />
                                        <label htmlFor="withApp">Jag vill ha ersättning som en värdekod</label>
                                    </div>

                                    <div className={errors.refundpreference ? "has-error" : ""}>
                                        <Field
                                            id="withTravelcard"
                                            type="radio"
                                            name="refundpreference"
                                            value={BANKDEPOSIT}
                                            checked={values.refundpreference === BANKDEPOSIT}
                                        />
                                        <label htmlFor="withTravelcard">Jag vill ha ersättning till mitt bankkonto</label>
                                    </div>
                                </div>
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
